import { theme } from 'antd';
import { useNavigate } from 'react-router-dom';

const templates = [
  { id: '111', name: 'Kho sỉ ăn vặt', url: 'https://shopanvatthuytien.sipro.app' },
  { id: '112', name: 'Tổng kho gia dụng', url: 'https://shopanvatthuytien.sipro.app' },
  { id: '113', name: 'Kho Buôn Sỉ Váy Thiết Kế', url: 'https://shopanvatthuytien.sipro.app' },
];

const useSelectTemplate = () => {
  const { token } = theme.useToken();
  const navigate = useNavigate();

  const viewTemplate = (url) => {
    window.location = url;
  };

  const copyTemplate = (templateId) => {
    navigate(`/shop-create?teplate_id=${templateId}`);
  };

  const goRegister = () => {
    navigate('/register');
  };

  const goLogin = () => {
    navigate('/login');
  };

  return {
    token,
    templates,
    viewTemplate,
    copyTemplate,
    goRegister,
    goLogin,
  };
};

export default useSelectTemplate;
